"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Slide = _interopRequireDefault(require("@mui/material/Slide"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var SlideTransition = function SlideTransition(props) {
  return /*#__PURE__*/_react["default"].createElement(_Slide["default"], _extends({}, props, {
    direction: "up"
  }));
};
var _default = exports["default"] = SlideTransition;